export const ProjectName = "./"
export const BASE_URL = "https://websvr.caribex.com/api/"
export const URL_UI = `https://websvr.caribex.com/`